import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  DecimalScale,
  FilterType,
  FormDialogMode,
  UserPermission
} from '@globaleris/ui.library'
import { Button } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EnumCommodity } from '../../../../api/Argentia/enums'
import { EnumTipoUsoGas } from '../../../../api/Argentia/enums/enumTipoUsoGas'
import { EnumTipoUsoPWR } from '../../../../api/Argentia/enums/enumTipoUsoPWR'
import { UseModel } from '../../../../api/Argentia/model/contracts'
import { EnumEstadoUso } from '../../../../api/oData/enums/enumEstadoUso'
import { EnumTipoUso } from '../../../../api/oData/enums/enumTipoUso'
import { DataTableErrorHandler } from '../../../../components/errors/scopes/dataTable/dataTableError'
import { EmptyContent } from '../../../../components/shared/emptyCardContent/emptyContent'
import { enumToSelectOptionArray, generateUniqueKeyWithNoPrefix } from '../../../../helpers'
import { startDateIsBeforeEndDate } from '../../../../helpers/formValidationsHelper'
import { getUserPermissions } from '../../../../helpers/permissionsHelper'
import {
  FormDialogDefinitionProps,
  useConfirmationDialog,
  useFormDialog,
  useHttpError
} from '../../../../hooks'
import { ConfirmationDialogs } from '../../../../model/enums/confirmationDialogs'
import { Pages } from '../../../../model/RBAC/constants'
import { getCustomerDomain } from '../../../../redux'
import {
  // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
  // mapPercentageSumOfAllUses,
  // mapPercentageSumOfOtherUses,
  mapUseFormData,
  mapUsesTable
} from '../../uses.mapper'

export interface UsesTableProps {
  listUsesData: UseModel[]
  handleStateUpdate?: (rowData: UseModel[]) => void
  handleAddUse?: (rowData: UseModel) => void
  handleEditUse?: (rowData: UseModel, oldData: UseModel) => void
  handleDeleteUse?: (rowData: UseModel) => void
  fabAndRowActionsAllowed?: boolean
  commodity?: EnumCommodity
  customCaption?: string
}

export const UsesTable: React.FC<UsesTableProps> = ({
  listUsesData,
  handleStateUpdate,
  handleAddUse,
  handleEditUse,
  handleDeleteUse,
  fabAndRowActionsAllowed = true,
  commodity,
  customCaption
}) => {
  const [dataList, setDataList] = useState<UseModel[]>(listUsesData)
  const [newDataForm, setNewDataForm] = useState<UseModel>({} as UseModel)
  // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
  // const [cumulativePercentage, setCumulativePercentage] = useState<number>(
  //   mapPercentageSumOfAllUses(mapUsesTable(listUsesData))
  // )
  const [dateValidationError, setDateValidationError] = useState<boolean>(false)
  // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro
  // const [percentageValidationError, setPercentageValidationError] = useState<boolean>(false)
  const [t] = useTranslation(['globalerisLibrary', 'uses', 'enums'])
  const { errorProps } = useHttpError()
  const {
    openForm,
    updateFormDefinition,
    updateFormData,
    closeForm,
    formProps,
    CustomFormDialog,
    setFormWaiting
  } = useFormDialog()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  // #region Handlers Starts
  const handleInsertRow = async (): Promise<boolean> => {
    // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
    // let totalpercentage = mapPercentageSumOfAllUses(mapUsesTable(dataList))
    // setCumulativePercentage(totalpercentage)
    openForm({
      definition: usesFormDefinition,
      title: t('uses:components.usesDataTable.forms.add.title'),
      mode: FormDialogMode.ADD,
      isWaiting: false,
      // inputData: { ...newDataForm, cumulativePercentage: totalpercentage} as UseModel,
      inputData: newDataForm,
      onClose: handleInsertRowFormClose
    })

    return true
  }

  const handleInsertRowFormClose = (formData: UseModel) => {
    if (formData) {
      const newDataList: UseModel[] = [
        ...dataList,
        {
          ...mapUseFormData(formData),
          tempId: generateUniqueKeyWithNoPrefix()
        }
      ]
      setDataList(newDataList)
      // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
      // setCumulativePercentage(mapPercentageSumOfAllUses(mapUsesTable(newDataList)))
      handleStateUpdate && handleStateUpdate(newDataList)
      handleAddUse && handleAddUse(mapUseFormData(formData))
    }
    setNewDataForm({} as UseModel)
    setDateValidationError(false)
    // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
    // setPercentageValidationError(false)
    closeForm()
  }

  const handleEditRow = (rowData: UseModel) => {
    const oldData: UseModel = { ...rowData }
    // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
    // let totalpercentage = mapPercentageSumOfOtherUses(
    //   mapUsesTable(dataList),
    //   rowData.id,
    //   rowData.tempId
    // )
    // setCumulativePercentage(totalpercentage)

    openForm({
      definition: usesFormDefinition,
      title: t('uses:components.usesDataTable.forms.edit.title'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      inputData: {
        ...rowData /* BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: , cumulativePercentage: totalpercentage */
      },
      onClose: formData => {
        handleEditRowFormClose(formData, oldData)
      }
    })
  }

  const handleEditRowFormClose = (formData: UseModel, oldData: UseModel) => {
    if (formData) {
      const newDataList = dataList.map(e => {
        if (e.id != undefined && e.id === formData.id) {
          return mapUseFormData(formData)
        } else if (e.tempId != undefined && e.tempId === formData.tempId) {
          return mapUseFormData(formData)
        } else {
          return e
        }
      })
      setDataList(newDataList)
      handleStateUpdate && handleStateUpdate(newDataList)
      handleEditUse && handleEditUse(mapUseFormData(formData), mapUseFormData(oldData))
    }
    setDateValidationError(false)
    // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
    // setPercentageValidationError(false)
    // setCumulativePercentage(mapPercentageSumOfAllUses(mapUsesTable(dataList)))
    closeForm()
  }

  const handleDeleteRow = async (rowData: UseModel) => {
    if (rowData) {
      await getConfirmation(ConfirmationDialogs.DELETE).then(async () => {
        const newDataList = dataList.filter(e => {
          if (rowData.id != undefined && e.id === rowData.id) {
            return false
          } else if (rowData.tempId != undefined && e.tempId === rowData.tempId) {
            return false
          } else {
            return true
          }
        })
        setDataList(newDataList)
        handleStateUpdate && handleStateUpdate(newDataList)
        handleDeleteUse && handleDeleteUse(rowData)
        closeConfirmation()
      })
    }
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  const enumTipoUsoByCommodity =
    commodity === EnumCommodity.GasNatural
      ? EnumTipoUsoGas
      : commodity === EnumCommodity.Electricidad
        ? EnumTipoUsoPWR
        : EnumTipoUso

  // #endregion Functions Ends

  // #region Form Definition Starts

  const usesFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'EDIT_ADD_USES',
        sections: [
          {
            inputs: [
              {
                name: 'useType',
                label: t('uses:components.usesDataTable.forms.add.inputs.useType'),
                type: DataType.SELECT,
                selectOptions: enumToSelectOptionArray(enumTipoUsoByCommodity, 'enums:EnumTipoUso'),
                required: true
              },
              {
                name: 'state',
                label: t('uses:components.usesDataTable.forms.add.inputs.state'),
                type: DataType.SELECT,
                selectOptions: enumToSelectOptionArray(EnumEstadoUso, 'enums:EnumEstadoUso'),
                required: true
              },
              // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
              // {
              //   name: 'cumulativePercentage',
              //   label: t('uses:components.usesDataTable.forms.add.inputs.cumulativePercentage'),
              //   type: DataType.NUMBER,
              //   defaultValue: cumulativePercentage,
              //   helpText: t(
              //     'uses:components.usesDataTable.forms.add.helptext.cumulativePercentage'
              //   ),
              //   readOnly: true
              // },
              {
                name: 'percentage',
                label: t('uses:components.usesDataTable.forms.add.inputs.percentage'),
                type: DataType.NUMBER,
                decimalScale: DecimalScale.DEFAULT,
                minValue: 0.01,
                maxValue: 100,
                // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: desactivado hasta migrar validación al API con filtro por rango de fechas
                // errorState: percentageValidationError,
                // errorText: t(
                //   'uses:components.usesDataTable.forms.validations.cumulativePercentageIsOver100'
                // ),
                onChange: (value, formState) => {
                  updateFormData(formState)
                  // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro
                  // setPercentageValidationError(cumulativePercentage + +value > 100)
                },
                required: true
              },
              {
                name: 'startDate',
                label: t('uses:components.usesDataTable.forms.add.inputs.startDate'),
                type: DataType.DATE,
                errorState: dateValidationError,
                errorText: t(
                  'uses:components.usesDataTable.forms.validations.startDateIsBeforeEndDate'
                ),
                onChange: (value, formState) => {
                  const formData = formState as UseModel
                  updateFormData(formState)
                  setDateValidationError(
                    !startDateIsBeforeEndDate(formData.startDate, formData.endDate)
                  )
                },
                required: true
              },
              {
                name: 'endDate',
                label: t('uses:components.usesDataTable.forms.add.inputs.endDate'),
                type: DataType.DATE,
                errorState: dateValidationError,
                clearable: true,
                onChange: (value, formState) => {
                  const formData = formState as UseModel
                  updateFormData(formState)
                  setDateValidationError(
                    !startDateIsBeforeEndDate(formData.startDate, formData.endDate)
                  )
                }
              }
            ]
          }
        ]
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      // BUG 77181 - PorcentajeAcumuladoSumaSinFiltro: removido percentageValidationError y cumulativePercentage de dependencias
    }, [dateValidationError])
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'tempId',
      display: false
    },
    {
      name: 'useType',
      label: t('uses:components.usesDataTable.dataTable.inputs.useType'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(enumTipoUsoByCommodity, 'enums:EnumTipoUso')
    },
    {
      name: 'percentage',
      label: t('uses:components.usesDataTable.dataTable.inputs.percentage'),
      type: DataType.NUMBER
    },
    {
      name: 'startDate',
      label: t('uses:components.usesDataTable.dataTable.inputs.startDate'),
      type: DataType.DATE
    },
    {
      name: 'endDate',
      label: t('uses:components.usesDataTable.dataTable.inputs.endDate'),
      type: DataType.DATE
    },
    {
      name: 'state',
      label: t('uses:components.usesDataTable.dataTable.inputs.state'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumEstadoUso, 'enums:EnumEstadoUso')
    }
  ]

  const options: DataTableOptions = {
    analytics: {
      customer: getCustomerDomain(),
      view: t('uses:components.usesDataTable.analytics')
    },
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: false,
    elevation: 0,
    filterType: FilterType.NONE,
    download: false,
    canEdit: false,
    canDelete: false,
    canInsert: fabAndRowActionsAllowed,
    customInsertEditModal: true,
    pagination: true,
    rowsPerPage: 10,
    rowsPerPageOptions: undefined,
    onRowInsert: handleInsertRow,
    rowCustomActions: [
      {
        icon: <Edit fontSize="small" />,
        tooltip: t('uses:components.usesDataTable.dataTable.actions.edit'),
        onClick: handleEditRow,
        userPermission: UserPermission.EDIT
      },
      {
        icon: <Delete fontSize="small" />,
        tooltip: t('uses:components.usesDataTable.dataTable.actions.delete'),
        onClick: handleDeleteRow,
        userPermission: UserPermission.EDIT
      }
    ]
  }
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  useEffect(() => {
    updateFormDefinition(usesFormDefinition)
  }, [usesFormDefinition])
  // #endregion Hooks Ends

  return (
    <>
      {dataList.length > 0 ? (
        <DataTable
          data={mapUsesTable(dataList)}
          columns={columns}
          options={options}
          info={DataTableErrorHandler(errorProps)}
          userPermissions={
            fabAndRowActionsAllowed ? getUserPermissions(Pages.Client) : [UserPermission.READ_ONLY]
          }
        />
      ) : (
        <EmptyContent
          caption={
            customCaption != undefined ? customCaption : t('uses:components.emptyCard.caption')
          }
        >
          {fabAndRowActionsAllowed && (
            <Button size="small" color="primary" variant="contained" onClick={handleInsertRow}>
              {t('uses:components.emptyCard.buttonLabel')}
            </Button>
          )}
        </EmptyContent>
      )}
      <CustomFormDialog {...formProps} />
    </>
  )
}
